import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    pure: true,
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  nop = (item) => true;
  transform(value: Array<any> = [], filter: (item: any, index?: number) => boolean = this.nop) {
    if (!value) {
      return value;
    }
    return value.filter(filter);
  }
}
